import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import { useDispatch } from "react-redux";

const ColorButton = styled("div")(({ theme }) => ({
  width: 28,
  height: 28,
  // borderRadius: "100%",
  borderRadius: theme.spacing(0.5),
  cursor: "pointer",
  marginTop: theme.spacing(1),
  marginRight: theme.spacing(1),
  border: "1px solid",
  borderColor: theme.palette.grey[400],
  "&:hover": {
    boxShadow: "0 1px 5px 0 rgba(90,90,90,.5)",
  },
}));

export default function ColorOption({
  option,
}: {
  option: any;
}): React.ReactElement {
  const { colors } = useTemplate();
  const dispatch = useDispatch();

  const setActiveColorId = (colorId: number) => {
    dispatch({
      type: "TEMPLATE_INIT_SET",
      data: {
        activeColorId: colorId,
      },
    });
  };

  const handleClick = (value) => {
    const activeColor = colors.find((item) => item.name === value.value);
    if (activeColor) {
      setActiveColorId(activeColor.id);
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", mt: -0.5 }}>
      {option.values.map((value, index) => {
        return (
          <Tooltip key={index} title={value.value} arrow={true} placement="top">
            <ColorButton
              style={{ backgroundColor: value.data }}
              onClick={() => handleClick(value)}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
}
